import React from 'react';

/** Subheading — smaller section subhead. data: { text } */
export default function Subheading({ data = {} }) {
  const { text = '' } = data;
  if (!text) return null;
  return (
    <section data-testid="site-block-subheading">
      <div className="max-w-6xl mx-auto px-6 pt-4 pb-2">
        <p className="text-base lg:text-lg font-semibold orka-text-secondary">{text}</p>
      </div>
    </section>
  );
}
